export var newUserSignupPlaceholderId = '<new-user>';